<div class="content">
  <h3>{{ title }}</h3>
  <p class="note-text">{{ params.note }}</p>
</div>
<div class="actions">
  <cs-button large secondary icon="edit" (click)="onEditClick()">
    {{ LL.common.buttons.edit() }}
  </cs-button>
</div>
